import {Component, inject, computed} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MatButtonModule} from '@angular/material/button';
import {MatIconModule} from '@angular/material/icon';
import {AuthService} from '@on-the-go-web/helpers/services/auth.service';
import {TranslatePipe} from '@ngx-translate/core';
import {Router} from '@angular/router';

@Component({
  selector: 'otg-security-prompt',
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatIconModule, TranslatePipe],
  templateUrl: './security-prompt.component.html',
  styleUrl: './security-prompt.component.scss',
})
export class SecurityPromptComponent {
  public authService = inject(AuthService);
  private _router = inject(Router);

  showPrompt = computed(() => this.authService.showSecurityPrompt());

  dismiss() {
    this.authService.dismissSecurityPrompt();
  }

  setPassword() {
    this.authService.dismissSecurityPrompt();
    this._router.navigate(['/settings/security/reset-password']);
  }
}
